import { useDeleteUser } from "http-hooks/users/useUsers";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteUser({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteUser();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete User"
      description="Are you sure you want to delete this user? This user will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}

